<h1 class="mBottom2" *ngIf="formMode === 'create'; else titleEditAlarm">
  {{ "ALARM.CREATE" | translate }}
</h1>
<ng-template #titleEditAlarm>
  <h1 class="mBottom2">{{ "ALARM.EDIT" | translate }}</h1>
</ng-template>

<form [formGroup]="alarmForm" (ngSubmit)="onSubmitForm(alarmForm.value)">
  <div class="inputForm">
    <mat-form-field appearance="outline">
      <mat-label>{{ "DASHBOARD.FORM.LABEL_NAME" | translate }}</mat-label>
      <input maxlength="30" type="text" matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ "ALARM.SUBJECT" | translate }}</mat-label>
      <input maxlength="30" matInput formControlName="subject" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ "ALARM.BODY" | translate }}</mat-label>
      <textarea matInput formControlName="body"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ "ALARM.DESCRIPTION" | translate }}</mat-label>
      <textarea matInput formControlName="description"></textarea>
    </mat-form-field>

    <mat-form-field *ngIf="formMode === 'create'" appearance="outline">
      <mat-label>{{ "ALARM.TYPE" | translate }}</mat-label>
      <mat-select
        (selectionChange)="changeSelection($event)"
        formControlName="type"
      >
        <mat-option
          *ngFor="let type of alarmTypeCollection"
          [value]="type.uuid"
        >
          {{ type.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ "ALARM.VALUE" | translate }}</mat-label>
      <input matInput type="number" formControlName="value" />
    </mat-form-field>

    <div
      *ngIf="alarm.state == 'Alarmada' && formMode === 'create'"
      class="alert alert-warning"
    >
      <strong>{{ "ALARM.ATENTION" | translate }}</strong>
      {{ "ALARM.ADVICE" | translate }}
    </div>

    <mat-label *ngIf="formMode === 'create'" class="db">{{
      "ALARM.STATE" | translate
    }}</mat-label>
    <mat-radio-group
      *ngIf="formMode === 'create'"
      aria-labelledby="example-radio-group-label"
      [color]="'primary'"
      formControlName="state"
    >
      <mat-radio-button class="rbAlarmState" [value]="'Activada'">{{
        "ALARM_TABLE.Activada" | translate
      }}</mat-radio-button>
      <mat-radio-button class="rbAlarmState" [value]="'Desactivada'">{{
        "ALARM_TABLE.Desactivada" | translate
      }}</mat-radio-button>
    </mat-radio-group>

    <div *ngIf="formMode === 'create'" class="row">
      <div class="col-md-9">
        <input
          type="button"
          class="btn sausageSelectBtn"
          [matMenuTriggerFor]="menu"
          value="{{ 'TAB_STEPPER.SELECT_FACTORY' | translate }}"
        />
        <div>
          <mat-menu #menu class="factorySelectionMenu userMenu">
            <div *ngFor="let factory of factoryCollection?.collection">
              <mat-checkbox
                [checked]="factory.selected"
                class="mat-menu-item factoryMenu"
                (click)="selectFactoryEvent(factory)"
                >{{ factory.name }}</mat-checkbox
              >
            </div>
          </mat-menu>
        </div>
        <div class="space20"></div>
        <div *ngIf="factoryCollectionSelected?.length < 1">
          <div class="container mtop5">
            <div class="text-center">
              <app-svg name="no-factory"></app-svg>
            </div>
            <div class="text-center warning-factories">
              <h3>{{ "WARNING_MESSAGES.NO_DEVICES" | translate }}</h3>
              <p>{{ "TAB_STEPPER.CLICK_TO_ADD_FACTORY" | translate }}</p>
            </div>
          </div>
        </div>
        <mat-tab-group
          animationDuration="0"
          *ngIf="factoryCollectionSelected?.length > 0"
        >
          <div *ngFor="let factory of factoryCollectionSelected; let i = index">
            <mat-tab [label]="factory.descripcion">
              <div class="container mtop5">
                <div class="row">
                  <div class="col-md-12 mBottom5">
                    <app-graphis-devices-hierarchi
                      [title]="title[i]"
                      [deviceChildrenList]="childrens[i]"
                      (deviceItemSelected)="selectedDeviceGraphItem($event)"
                      (deviceItemUnSelected)="unSelectedDeviceGraphItem($event)"
                      (deviceItemNavegate)="navigate($event, i)"
                      (goBackOnDevices)="goBack(i)"
                      [loadingChildren]="loading[i]"
                      [isRoot]="isRoot[i]"
                    >
                    </app-graphis-devices-hierarchi>
                  </div>
                </div>
              </div>
            </mat-tab>
          </div>
        </mat-tab-group>
      </div>

      <div class="col-md-3">
        <div class="resumeTitleSection larger mBottom5">
          {{ "ALARM.DEVICE_SELECTED" | translate }}
        </div>
        <p *ngIf="selectedDeviceList.length < 1" class="text-left">
          {{ "TAB_STEPPER.NO_DEVICES_SELECTED" | translate }}
        </p>
        <mat-chip-list #chipList>
          <mat-chip
            class="unselectable btnForm w100 mBottom5"
            *ngFor="let device of selectedDeviceList"
            (removed)="removeChipset(device)"
          >
            <div class="col-md-10">{{ device.name }}</div>
            <div class="col-md-2">
              <mat-icon class="chipsetCancelInAlarm" matChipRemove
                >cancel</mat-icon
              >
            </div>
          </mat-chip>
        </mat-chip-list>

        <div class="resumeTitleSection larger">
          {{ "ALARM.DATATYPE_SELECTED" | translate }}
        </div>
        <p *ngIf="selectedDeviceList.length < 1" class="text-left">
          {{ "TAB_STEPPER.NO_DATATYPES_SELECTED" | translate }}
        </p>
        <div
          *ngIf="dataTypeSelected !== null && dataTypeSelected !== undefined"
        >
          <div *ngFor="let item of dataTypeSelected">
            <mat-chip
              class="unselectable btnForm margin4"
              *ngIf="item?.name !== null"
              >{{ item?.name }}
            </mat-chip>
          </div>
        </div>

        <div class="space20"></div>

        <div class="heightDatatype">
          <!-- //TODO: Revisar conflicto de tipado -->
          <!-- <app-alarm-data-type-navigate [dataTypeSelectedCollection]="dataTypeSelected"
                        [dataTypeChildrenList]="dataTypeTree" [deviceDatatype]="devicesSelectedSubject"
                        (datatypeItemSelected)="selectedDatatype($event)"
                        (datatypeItemUnSelected)="unSelectedDatatype($event)" [loadingChildren]="loading">
                    </app-alarm-data-type-navigate> -->
          <app-alarm-data-type-navigate
            [dataTypeSelectedCollection]="dataTypeSelected"
            [dataTypeChildrenList]="dataTypeTree"
            [deviceDatatype]="devicesSelectedSubject | async"
            (datatypeItemSelected)="selectedDatatype($event)"
            (datatypeItemUnSelected)="unSelectedDatatype($event)"
            [loadingChildren]="loading[0]"
          >
          </app-alarm-data-type-navigate>
        </div>
      </div>
    </div>
  </div>

  <button mat-raised-button (click)="cancelForm()">
    {{ "DASHBOARD.FORM.CANCEL" | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    class="right"
    [disabled]="isDataEmpty()"
    cdkFocusInitial
    type="submit"
  >
    {{ "DASHBOARD.FORM.ACCEPT" | translate }}
  </button>
</form>
